module.exports = __webpack_public_path__ + "img/panoply.45406eeb.jpg";